import gql from 'graphql-tag'

const GC_GET_SCENARIO_LIST = gql`
query GetScenarioList {
  scenario {
    id
    name
    locations: scenarioLocations {
      id: location_id,
    }
    type: scenarioType {
      id
      slug
    }
    nodeInfo: nodes_aggregate {
      aggregate {
        count
      }
    }
  }
}
`

const GC_GET_SCENARIO_BY_ID = gql`
query ScenarioByID($id: uuid!) {
  scenario(where: {id: {_eq: $id}}) {
    id
    name
    description
    type: scenarioType {
      id
      slug
    }
    locations: scenarioLocations {
      location {
        id
        title
        slug
        order
      }
    }
    nodes {
      id
      title
      node_content
      scenario_id
      triggers {
        id
        name
        node_id
        triggered_node_id
        triggerType {
          slug
        }
      }
      type: nodeType {
        slug
      }
    }
  }
}
`

const GC_GET_SCENARIOS_FIRST_NODE_CONDIDATES = gql`
query ScenarioFirstNodeCandidates {
  node(where: {_not: {triggersByTriggeredNodeId: {}}, _and: {nodeType: {slug: {_eq: "scene"}}}}, order_by: {scenario_id: asc}) {
    id
    scenario_id
    triggers {
      name
      triggered_node_id
      type: triggerType {
        slug
      }
    }
  }
}
`

export {
    GC_GET_SCENARIO_LIST,
    GC_GET_SCENARIO_BY_ID,
    GC_GET_SCENARIOS_FIRST_NODE_CONDIDATES
}